<p class="color-muted">
  {{ 'POPULATION_TOO_SMALL' | translate }}
</p>
